import script from "./Messages.vue?vue&type=script&setup=true&lang=js"
export * from "./Messages.vue?vue&type=script&setup=true&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=5f6f7a01&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6f7a01"]])

export default __exports__